
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useRef, useState } from "react";
import { Paper, Box, CircularProgress } from "@mui/material";
import theme from "../../../styles/Themecolors";
import { searchHSN } from "../../../graphql";

function UseHSNMaster({ Type,Page }) {
  const [filterHSN, setFilterHSN] = useState([]);
  const [row, setRow] = useState(0);
  const isFetchingRef = useRef(false);
  const [hsnIsLoading, setIsHsnLoading] = useState(false); 
  const resolveCodeTypes = () => {
    // Ledger lines can use either HSN or SAC.
    if (Page === "NONITEM") return ["HSN", "SAC"];
    // Item lines: filter by goods/service. Empty type defaults to HSN (goods).
    if (Type === "SERVICE") return ["SAC"];
    return ["HSN"];
  };

  async function searchHSNDetails(word, rowfrom, limitno) {
    try {
      const codeTypes = resolveCodeTypes();

      setIsHsnLoading(true);
      const responses = await Promise.all(
        codeTypes.map((codetype) =>
          API.graphql(
            graphqlOperation(searchHSN, {
              rowfrom,
              limitno,
              word,
              codetype,
            })
          )
        )
      );

      const seenIds = new Set();
      const arr = [];
      responses.forEach((res) => {
        (res?.data?.searchHSN || []).forEach((item) => {
          if (seenIds.has(item.hsnsacid)) return;
          seenIds.add(item.hsnsacid);
          arr.push({
            label: `${item.hsnsaccode} - ${item.description}`,
            value: `${item.hsnsaccode}`,
            companyID: item.companyid,
            hsnID: item.hsnsacid,
            codetype: item.codetype,
            description: item.description,
          });
        });
      });

      // setFilterHSN((prev) => [
      //   ...prev,
      //   ...arr.filter((newItem) => !prev.some((existingItem) => existingItem.hsnID === newItem.hsnID)),
      // ]);

      if (rowfrom === 0) {
        setFilterHSN(arr);
      } else {
        setFilterHSN((prev) => [
          ...prev,
          ...arr.filter((newItem) => !prev.some((existingItem) => existingItem.hsnID === newItem.hsnID)),
        ]);
      }
      setIsHsnLoading(false);
    } catch (error) {
      console.error("Error fetching HSN details:", error);
      setIsHsnLoading(false);
    }
  }

  useEffect(() => {
    setFilterHSN([])
    searchHSNDetails("", 0, 20);
  }, [Type,Page]);

  // useEffect(() => {
  //   searchHSNDetails("", row, 20).then(() => {
  //     isFetchingRef.current = false;
  //   });
  // }, [row]);

  // const handleScroll = (event) => {
  //   const listboxNode = event.target;
  //   const isBottom = listboxNode.scrollHeight - listboxNode.scrollTop <= listboxNode.clientHeight + 10;

  //   if (isBottom && !isFetchingRef.current) {
  //     isFetchingRef.current = true;
  //     setRow((prev) => prev + 20);
  //   }
  // };
  const handleScroll = (event) => {
    const listboxNode = event.target;
    const isBottom =
      listboxNode.scrollHeight - listboxNode.scrollTop <=
      listboxNode.clientHeight + 10;
  
    if (isBottom && !isFetchingRef.current) {
      isFetchingRef.current = true;
  
      setRow((prev) => {
        const newRow = prev + 20;
        
        // Call fetchData with the updated value
        searchHSNDetails("", newRow, 20).then(() => {
          isFetchingRef.current = false;
        });
  
        return newRow;
      });
    }
  };

  const HSNListboxProps = {
    onScroll: hsnIsLoading === false && handleScroll,
    sx: {
      maxHeight: "400px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.default}`,
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: theme.palette.background.default,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.primary.main,
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  };

  const PaperComponent = ({ children, ...props }) => (
    <Paper {...props} sx={{ maxHeight: "400px", overflowY: "auto" }}>
      {children}
      {hsnIsLoading && (
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            right: 0,
            display: "flex",
            justifyContent: "center",
            backgroundColor: theme.palette.background.default,
            p: 1,
            zIndex: 2,
          }}
        >
          <CircularProgress size={20} />
        </Box>
      )}
    </Paper>
  );

  return { filterHSN, setFilterHSN, searchHSNDetails, setIsHsnLoading, HSNListboxProps,setRow, PaperComponent };
}

export default UseHSNMaster;

